import { Sound } from "../../../shared/sound";

export const DefaultSoundEffectVolumes = new Map<Sound, number>(
	[
		[Sound.Collision, 1.2],
		[Sound.Explosion, 5],
		[Sound.Heal, 12],
		[Sound.Healwave, 12],
		[Sound.Shoot, 8],
		[Sound.Death, 18.75],
		[Sound.WaterPlop, 6],
		[Sound.Electricity, 0.5375],
		[Sound.ElectricalPop, 4],
		[Sound.SellChime, 7.5],
		[Sound.Promote, 0.7],
		[Sound.BloodCellDamage, 10],
		[Sound.ChainConnect, 40],
		[Sound.ChainDisconnect, 40],
		[Sound.Combine, 32.5],
		[Sound.PlaceCell, 3],
		[Sound.CollisionSmall, 25],
		[Sound.CollisionHeavy, 30],
		[Sound.GetResource, 5.4],
		[Sound.ProducedResource, 15],
		[Sound.Reward, 9],
		[Sound.HoverCell, 25],
		[Sound.Menu, 2],
		[Sound.ButtonClick, 2],
		[Sound.Heartbeat, 3.85],
		[Sound.ShopMusic, 1],
		[Sound.SimulationMusic, 0],
	]
);

export let DistanceVolumeReductionFactor = 5;